// Issue tracker statuses as the UI names them. Mirrors ISSUE_STATUSES in
// apps/api/src/modules/issues/issues.logic.ts — the stored values never change, only labels.
import type { BadgeProps } from "../components/ui/badge.js";

export const ISSUE_STATUS_LABELS: Record<string, string> = {
  open: "Open",
  in_progress: "Working",
  needs_info: "Needs info",
  deferred: "Deferred",
  resolved: "Resolved",
  retesting: "Retesting",
  closed: "Closed",
  reopened: "Reopened",
  not_a_bug: "Not a bug",
  duplicate: "Duplicate",
  wont_fix: "Won't fix",
};

export const ISSUE_STATUS_TONES: Record<string, NonNullable<BadgeProps["tone"]>> = {
  open: "info",
  in_progress: "warning",
  needs_info: "accent",
  deferred: "outline",
  resolved: "success",
  retesting: "accent",
  closed: "neutral",
  reopened: "error",
  not_a_bug: "neutral",
  duplicate: "neutral",
  wont_fix: "neutral",
};

/** Filter order on the Issues page. */
export const ISSUE_STATUS_ORDER = [
  "open", "in_progress", "needs_info", "reopened", "resolved", "retesting", "deferred", "closed",
  "not_a_bug", "duplicate", "wont_fix",
];

/** Targets of POST /issues/:id/status, with what each asks for. */
export const TRIAGE_ACTIONS: { status: string; label: string; needsReason: boolean; hint: string }[] = [
  { status: "in_progress", label: "Working on it", needsReason: false, hint: "Someone is actively fixing this." },
  { status: "needs_info", label: "Needs info", needsReason: false, hint: "Waiting on the reporter for details." },
  { status: "deferred", label: "Defer", needsReason: false, hint: "Valid, but parked until a later date." },
  { status: "not_a_bug", label: "Not a bug", needsReason: true, hint: "Works as designed. Closes the issue." },
  { status: "duplicate", label: "Duplicate of…", needsReason: true, hint: "Already reported. Closes it and links the original." },
  { status: "wont_fix", label: "Won't fix", needsReason: true, hint: "Valid, but not going to be fixed. Closes the issue." },
  { status: "open", label: "Back to open", needsReason: false, hint: "Unpark it for anyone to pick up." },
];

/** Statuses a reporter can reopen from (POST /issues/:id/reopen). */
export const ISSUE_REOPENABLE = ["resolved", "retesting", "closed", "deferred", "not_a_bug", "duplicate", "wont_fix"];

export function issueStatusLabel(status: string): string {
  return ISSUE_STATUS_LABELS[status] ?? status.replace(/_/g, " ");
}
